import BaseModel from './BaseModel'

export default class DealerTagNumber extends BaseModel {
  // ... DealerTagNumber-specific methods or overrides ...
}
